module.exports = __webpack_public_path__ + "media/thq.a629c9ee.mp4";